<template>
  <el-switch @change="change" v-model="usingPrivateRate"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      usingPrivateRate: false
    }
  },
  beforeMount() {
    this.usingPrivateRate = (this.params.data.using_private_rate === 1)
  },
  methods: {
    change(val) {
      let apiData = {
        value: val,
        userId: this.params.data.user_id
      }

      let rowData = this.params.data
      rowData.using_private_rate = this.usingPrivateRate

      let params = {
        apiData,
        rowData
      }
      this.params.props.actionsHandler('setUserUsingPrivateRate', params)
    }
  }
}
</script>
